<template>
  <div class="m-activity-sendCoupon-add">
    <div class="title">基本设置</div>
    <el-form v-if="isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="120px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" />
      </el-form-item>
      <el-form-item label="活动时间" prop="activityDate">
        <el-date-picker
          v-model="form.activityDate"
          type="datetimerange"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
          format="yyyy/MM/dd HH:mm"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发券场景" prop="scene">
        <el-radio-group v-model="form.scene" :disabled="$route.query.id?true:false">
          <el-radio label="AfterPay">支付发券</el-radio>
          <el-radio label="Register">注册发券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发券范围" prop="useRange">
        <el-radio-group v-model="form.useRange" @input="onUseRangeChange">
          <el-radio label="Generic">全场通用</el-radio>
          <el-radio label="Mall" v-if="form.scene == 'AfterPay'">指定商场</el-radio>
          <el-radio label="Store" v-if="form.scene == 'AfterPay'">指定店铺</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="参与限制" prop="userDaily"  v-if="form.scene == 'AfterPay'">
        <el-radio-group v-model="form.userDaily" @change="limitRadioChange('userDailyLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每人每天可参与</span>
            <el-form-item label="" prop="userDailyLimit">
              <el-input v-model="form.userDailyLimit" placeholder="请输入" :disabled="form.userDaily !== '2'" oninput="value=value.replace(/[^\d]/g,'')">
                <template slot="append">次</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.useRange === 'Mall'" :class="`mall-select-box`" prop="mallIds" label="" label-width="0">
        <el-select v-model="form.mallIds" placeholder="请选择商场" multiple>
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.useRange === 'Store'" :class="`store-select-box`" prop="storeIds" label="" label-width="0">
        <el-cascader
          v-model="form.storeIds"
          placeholder="请选择店铺"
          :options="storeTreeData"
          :props="storeCascaderProps"
          clearable
          collapse-tags
          :filterable="true"
          :show-all-levels="false"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item v-if="form.scene == 'AfterPay'" label="发券门槛" prop="requireAmount">
        <el-input v-model="form.requireAmount" oninput="value=value.replace(/[^.\d.]/g,'')" placeholder="请输入" >
          <template slot="prepend">订单实付金额满足</template>
          <template slot="append">元送券</template>
        </el-input>
        <span class="input-remark">（0元代表无门槛）</span>
      </el-form-item>
      <el-form-item label="优惠券" prop="coupons">
        <el-select :disabled="!!$route.query.id" v-model="form.coupons" placeholder="请选择优惠券" @change="v => onCouponChange(v, 'coupon')" multiple collapse-tags filterable>
          <el-option v-for="item in couponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_coupon" :tableTrData="tableTrData_coupon" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #type="{ row }">{{ row.type }}</template>
          <template #detail="{ row }">{{ row.detail }}</template>
          <template #require="{ row }">{{ row.require }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_coupon')}]" >
              <el-input v-model="tableTrData_coupon[scope.$index].amount" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="礼品券" prop="giftCoupons">
        <el-select :disabled="!!$route.query.id" v-model="form.giftCoupons" placeholder="请选择礼品券" @change="v => onCouponChange(v, 'gift')" multiple collapse-tags filterable>
          <el-option v-for="item in giftCouponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_gift" :tableTrData="tableTrData_gift" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #subTitle="{ row }">{{ row.subTitle }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
          <template #description="{ row }">
            <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_gift')}]" >
              <el-input v-model="tableTrData_gift[scope.$index].amount" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="停车券" prop="parkingCoupons" v-if="form.scene == 'AfterPay'">
        <el-select :disabled="!!$route.query.id" v-model="form.parkingCoupons" placeholder="请选择停车券" @change="v => onCouponChange(v, 'parkingCoupons')" multiple collapse-tags filterable>
          <el-option v-for="item in parkingCouponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table" v-if="form.scene == 'AfterPay'">
        <Table :tableThData="tableThData_parking" :tableTrData="tableTrData_parking" :pagination="false" >
          <template #mallName="{ row }">{{ row.mallName }}</template>
          <template #name="{ row }">{{ row.name }}</template>
          <template #discount="{ row }">{{ row.discount }}</template>
          <template #validTime="{ row }">{{ row.validTime }}</template>
          <template #remark="{ row }">
            <el-button v-if="row.remark" type="text" @click="onLookRemark(row,'parking')">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_parking')}]" >
              <el-input v-model="tableTrData_parking[scope.$index].amount" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
    </el-form>
    <div v-else class="base-info">
      <SeckillDetail :detailData="form"></SeckillDetail>
    </div>

    <div v-if="isEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">完成</el-button>
    </div>
    <div v-else-if="isCanEdit" class="button-box right">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit" :loading="submitLoading">编辑</el-button>
      </auth-button>
    </div>

    <div v-if="$route.query.page == 'detail'">
      <el-divider />
      <div class="title">领取记录</div>
      <GetRecord v-if="form.id"></GetRecord>
    </div>

    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Table from "@/components/Table/index";
import SeckillDetail from './components/detail.vue'
import GetRecord from './components/getRecord.vue'
import { api_getActivityBaseInfo, api_postSendCouponAdd, api_putSendCouponUpdate } from '@/api/market'
import { api_getListCoupon, api_getGiftListCoupon, api_getConfig } from '@/api/common'
import { api_getParkingCouponTemplate } from '@/api/parking'
export default {
  name: "marketActivitySendCouponAdd",
  components: {
    AuthButton,
    Table,
    SeckillDetail,
    GetRecord
  },
  data() {
    // 校验优惠券和礼品券不能都为空
    const checkCoupon = (rule, value, callback) => {
      const { field } = rule
      if ((field == 'coupons' 
	  && (this.form.giftCoupons && this.form.parkingCoupons && !this.form.giftCoupons.length && !this.form.parkingCoupons.length) || field == 'giftCoupons' 
	  && (this.form.coupons && this.form.parkingCoupons && !this.form.coupons.length && !this.form.parkingCoupons.length) || field == 'parkingCoupons' 
	  && (this.form.coupons && this.form.giftCoupons && !this.form.coupons.length && !this.form.giftCoupons.length) ) && value && !value.length) {
        callback(new Error('请至少选择一张优惠券或者礼品券'))
      } else {
        callback()
      }
    }

    // 校验表格中的输入框
    const checkTableForm = (rule, v, callback, scope, tableName) => {
      const { field } = rule
      const { $index } = scope
      const value = this[tableName][$index][field]
      if (field == 'amount' && !value) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    // 校验时间选择要大于当前时间
    const checkDate = (rule, value, callback) => {
      let startTime = this.$moment(value[0]).valueOf()
      let curTime = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).valueOf()
      if (!this.form.startSignUp && (startTime < curTime)) {
        callback(new Error('开始时间需要在当前时间之后'))
      } else {
        callback()
      }
    }

    return {
      loadingID: null,
      submitLoading: false,
      isEdit: true, // 表单是否是编辑状态
      isCanEdit: true, // 表单是否可编辑
      form: {
        scene: 'AfterPay',
        userDaily:'1',
        coupons: [],
        giftCoupons: [],
        parkingCoupons: []
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [
          { required: true, message: '请选择活动时间' },
          {validator: checkDate},
        ],
        sence: [{ required: true, message: '请选择发券场景' }],
        coupons: [{ validator: checkCoupon }],
        giftCoupons: [{ validator: checkCoupon }],
        parkingCoupons: [{ validator: checkCoupon }],
        requireAmount: [{ required: true, message: '请输入发券门槛' }],
        useRange: [{ required: true, message: '请选择参与限制' }],
        mallIds: [{ required: true, message: '请选择商场' }],
        storeIds: [{ required: true, message: '请选择店铺' }],
      },
      checkTableForm,
      couponListData: [], // 优惠券list数据
      giftCouponListData: [], // 礼品券list数据
      parkingCouponListData: [], // 停车券list数据
      tableThData_coupon: [
        { prop: "name", label: "优惠券名称", minWidth: "100", },
        { prop: "type", label: "优惠券类型", minWidth: "80", },
        { prop: "detail", label: "券优惠", minWidth: "80", },
        { prop: "require", label: "券门槛", minWidth: "80", },
        { prop: "useTime", label: "用券时间", minWidth: "80", },
        { prop: "amount", label: "数量", },
      ],
      tableTrData_coupon: [],
      tableThData_gift: [
        { prop: "name", label: "礼品券名称", minWidth: "120", },
        { prop: "subTitle", label: "标题", minWidth: "120", },
        { prop: "useTime", label: "券有效时间", minWidth: "100", },
        { prop: "useRangeType", label: "核销范围", minWidth: "80", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "数量", },
      ],
      tableTrData_gift: [],
      tableThData_parking: [
        { prop: "name", label: "停车券名称", minWidth: "110", },
        { prop: "discount", label: "抵扣优惠", minWidth: "110", },
        { prop: "validTime", label: "券有效时间", minWidth: "160", },
        { prop: "mallName", label: "核销范围", minWidth: "180", },
        { prop: "remark", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "数量", },
      ],
      tableTrData_parking: [],
      isShowRemarkDialog: false,
      currentRow: {},
      mallData: [], // 商场数据
      storeTreeData: [], // 店铺级联框树形数据
      storeCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      pickerOptions: {
        disabledDate: this.disabledDateFun,
      },
    };
  },
  async created() {
    await this.getCouponListData() // 获取优惠券列表数据
    await this.getGiftCouponListData() // 获取礼品券列表数据
    await this.getParkingCouponListData() // 获取停车券券列表数据
    this.form.type = this.$route.query.type
    this.getConfigData() // 获取config数据（商场、店铺级联框）
    if (this.$route.query.id) {
      this.getDetailData() // 获取详情数据
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.loadingID = this.$baseLoading(6)
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.isEdit = false
      let res = await api_getActivityBaseInfo({id: this.$route.query.id})
      console.log('基本信息res: ', res);
      if (res.status == 'Doing' || res.status == 'Ended') {
        this.isCanEdit = false
      }
      res.userDaily = res.userDailyLimit || res.userDailyLimit === 0 ? '2' : '1'
      this.form = {
        ...res,
        activityDate: [res.startTime, res.endTime], // 活动时间
        coupons: res.couponTemplate && res.couponTemplate.map(item => item.id),
        giftCoupons: res.giftCouponTemplate && res.giftCouponTemplate.map(item => item.id),
        parkingCoupons: res.lotCouponTemplate && res.lotCouponTemplate.map(item => item.id)
      }
      this.tableTrData_coupon = res.couponTemplate || []
      this.tableTrData_gift = res.giftCouponTemplate || []
      this.tableTrData_parking = res.lotCouponTemplate || []
      this.loadingID.close()
    },

    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall, storeThreeLevel} = await api_getConfig(['mall', 'storeThreeLevel'])
      this.mallData = mall
      this.storeTreeData = storeThreeLevel
    },

    // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData = res
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftCouponListData = res
    },

    // 获取停车券列表数据
    async getParkingCouponListData() {
      const res = await api_getParkingCouponTemplate()
      this.parkingCouponListData = res
    },

     // 限制 单选器改变
    limitRadioChange(name) {
      this.$refs.form.validateField(name)
      this.form[name] = null
      delete this.form[name]
    },
    // 优惠券下拉框改变
    onCouponChange(value, type) {
      if (type == 'coupon') {
        this.$refs.form.validateField('giftCoupons')
        let curCoupon = this.couponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_coupon = curCoupon.map(item => {
          let curTable = this.tableTrData_coupon.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      } else if(type == 'gift'){
        this.$refs.form.validateField('coupons')
        let curCoupon = this.giftCouponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_gift = curCoupon.map(item => {
          let curTable = this.tableTrData_gift.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      }else{
          this.$refs.form.validateField('parkingCoupons')
          let curCoupon = this.parkingCouponListData.filter(item => value.indexOf(item.id) >= 0)
          this.tableTrData_parking = curCoupon.map(item => {
          let curTable = this.tableTrData_parking.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      }
    },

    // 参与限制改变
    onUseRangeChange(value) {
      if (value == 'Mall') {
        delete this.form.storeIds
      } else if (value == 'Store') {
        delete this.form.mallIds
      } else {
        delete this.form.storeIds
        delete this.form.mallIds
      }
    },

    // 禁用日期
    disabledDateFun(date) {
      if (this.$moment(date).valueOf() < this.$moment().subtract(1, 'day').valueOf()) {
        return true
      }
    },

    // 点击提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let { activityDate } = this.form
            let params = {
              ...this.form,
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
              couponTemplate: this.disposeCoupons('coupon'),
              giftCouponTemplate: this.disposeCoupons('gift'),
              lotCouponTemplate: this.disposeCoupons('parking'),
            }

            !params.id && (params.disable = false) // 创建活动时默认状态
            delete params.activityDate // 删除活动时间原始数据
            delete params.coupons
            delete params.giftCoupons
            delete params.parkingCoupons
            delete params.userDaily
            console.log('params: ', params);
            // return

            let res = params.id ? await api_putSendCouponUpdate(params) : await api_postSendCouponAdd(params)
            console.log('res: ', res);
            this.$baseMessage('保存成功', 'success')
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id
              }
            })
            this.getDetailData()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 处理优惠券、礼品券保存数据
    disposeCoupons(type) {
      let listData = []
      switch (type) {
        case 'coupon':
          listData =  this.tableTrData_coupon
          break;
        case 'gift':
          listData =  this.tableTrData_gift
          break;
        case 'parking':
          listData =  this.tableTrData_parking
          break;
        default:
          break;
      }
      return listData.map(item => {
        const { id, amount } = item
        return {
          id,
          amount,
        }
      })
    },

    // 查看使用须知
    onLookRemark(row,type) {
      this.currentRow = row
      if(type == 'parking'){
        this.currentRow.description = row.remark
      }
      this.isShowRemarkDialog = true
    },

    // 点击编辑按钮
    onEdit() {
      this.isEdit = true
    },

    // 点击取消
    onCancel() {
      if (this.$route.query.id) {
        this.isEdit = false
      } else {
        this.$router.back(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-sendCoupon-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }
   .limit-pay-box {
    .el-radio__label {
    .el-form-item {
      display: inline-block;
      margin: 0;
      margin-left: 20px;
      .el-input {
        width: 190px !important;
      }
    }
   }
  }
  .coupon-table {
    width: 90%;
    margin-left: 120px;
    margin-bottom: 20px;

    .table-price-box {
      display: flex;

      .text {
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 400px;
    bottom: 0;
  }

  .mall-select-box {
    margin-left: 230px;

    &.left2 {
      margin-left: 130px;
    }
  }

  .store-select-box {
    margin-left: 340px;
    &.left2 {
      margin-left: 240px;
    }
  }


  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .button-box{
    text-align: left;
    margin-top: 50px;

    &.right {
      text-align: right;
    }
  }
}
</style>
